import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _createForOfIteratorHelper from "@babel/runtime/helpers/createForOfIteratorHelper";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { HTML_ATTRIBUTE_CAPTURE_PREFIX, HTML_ATTRIBUTE_CAPTURE_CLICK_PREFIX, HTML_ATTRIBUTE_CAPTURE_SUFFIX, HTML_ATTRIBUTE_BLOCKER_CONNECTED, findVisualParentForContentBlocker } from ".";
import { transformTcfSrc } from "../../tcf";
import { OPT_IN_CONTENT_BLOCKER_ALL } from "../../types";
import { ensureScriptWrapper } from "./ensureScriptWrapper";
/**
 * Transform e. g. `consent-original-href` to `href` of a given node.
 */

function transformToOriginalContentBlockerAttribute(node, allowClickOverrides) {
  return new Promise(function (resolve) {
    // Scripts need to be handled differently cause we want to use `postscribe` and should not be attached
    // to the DOM -> not be executed
    var tagName = node.tagName.toLowerCase();
    var isScript = tagName === "script";
    var workWithNode = isScript ? node.cloneNode(true) : node; // Do the transformation from "blocked" state to "unblocked"

    var _iterator = _createForOfIteratorHelper(workWithNode.getAttributeNames()),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var attribute = _step.value;

        if (attribute.startsWith(HTML_ATTRIBUTE_CAPTURE_PREFIX) && attribute.endsWith(HTML_ATTRIBUTE_CAPTURE_SUFFIX)) {
          var originalAttribute = attribute.substr(HTML_ATTRIBUTE_CAPTURE_PREFIX.length + 1);
          originalAttribute = originalAttribute.slice(0, (HTML_ATTRIBUTE_CAPTURE_SUFFIX.length + 1) * -1); // Check if `allowClickOverride` is given and then the `consent-click-original` attribute may be used, if given

          var overwriteClickAttribute = "".concat(HTML_ATTRIBUTE_CAPTURE_CLICK_PREFIX, "-").concat(originalAttribute, "-").concat(HTML_ATTRIBUTE_CAPTURE_SUFFIX);
          var value = workWithNode.getAttribute(workWithNode.hasAttribute(overwriteClickAttribute) && allowClickOverrides ? overwriteClickAttribute : attribute);

          if (process.env.IS_TCF === "1" && originalAttribute === "src") {
            value = transformTcfSrc(value);
          } // Finally, set the valid values


          workWithNode.setAttribute(originalAttribute, value);
          workWithNode.removeAttribute(attribute);
          workWithNode.removeAttribute(overwriteClickAttribute); // Automatically delegate a `click` event

          if (allowClickOverrides && ["a"].indexOf(tagName) > -1 && ["onclick"].indexOf(originalAttribute.toLowerCase()) > -1) {
            node.addEventListener(OPT_IN_CONTENT_BLOCKER_ALL, /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
                var unblockedNodes;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        unblockedNodes = _ref.detail.unblockedNodes;
                        return _context.abrupt("return", unblockedNodes.forEach(function () {
                          return node.click();
                        }));

                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x) {
                return _ref2.apply(this, arguments);
              };
            }());
          }
        }
      } // Are there any non-transformed clicked attributes? E.g. only add an attribute when it got clicked (without original attribute)

    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    var _iterator2 = _createForOfIteratorHelper(workWithNode.getAttributeNames()),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _attribute = _step2.value;

        if (_attribute.startsWith(HTML_ATTRIBUTE_CAPTURE_CLICK_PREFIX) && _attribute.endsWith(HTML_ATTRIBUTE_CAPTURE_SUFFIX)) {
          var _value = workWithNode.getAttribute(_attribute);

          var _originalAttribute = _attribute.substr(HTML_ATTRIBUTE_CAPTURE_CLICK_PREFIX.length + 1);

          _originalAttribute = _originalAttribute.slice(0, (HTML_ATTRIBUTE_CAPTURE_SUFFIX.length + 1) * -1); // Finally, set the valid values

          if (allowClickOverrides) {
            workWithNode.setAttribute(_originalAttribute, _value);
          }

          workWithNode.removeAttribute(_attribute);
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    workWithNode.style.removeProperty("display"); // Also make the parent visual visible again

    var _findVisualParentForC = findVisualParentForContentBlocker(node),
        _findVisualParentForC2 = _slicedToArray(_findVisualParentForC, 1),
        visualParent = _findVisualParentForC2[0];

    if (visualParent !== node || visualParent !== null && visualParent !== void 0 && visualParent.hasAttribute(HTML_ATTRIBUTE_BLOCKER_CONNECTED)) {
      visualParent.style.removeProperty("display");
    }

    if (!isScript) {
      resolve();
    } else {
      var outerHTML = workWithNode.outerHTML;
      ensureScriptWrapper(outerHTML, node).then(resolve);
    }
  });
}

export { transformToOriginalContentBlockerAttribute };